module.exports = __webpack_public_path__ + "static/media/banner-projects.e1c36f70.jpg";